import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'bz-core-controls/utils/reflect-metadata';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './registerServiceWorker';
import './bootstrap/carousel.styl';
import Moment from 'moment';
//import { library, dom } from '@fortawesome/fontawesome-svg-core';
//import { fas } from '@fortawesome/free-solid-svg-icons';

//library.add(fas);
//dom.watch();
ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
serviceWorker.register();

/* eslint-disable no-extend-native */
Date.prototype.toJSON = function () {
  return Moment(this).format('YYYY-MM-DDTHH:mm:ss');
};
/* eslint-enable no-extend-native */
